import { isValue } from './isValue';
/**
 *
 * @param {number} dividend divided in the calculation
 * @param {array} yearlyDivisors array of divisors that are yearly values
 * @param {array} monthlyDivisors array of divisors that are monthly values
 * @param {number} decimalPlaces number of decimal places to round to (default 2)
 * @returns calculated percentage as string or null
 */
export const yearlyPercentFromYearlyValue = (
  dividend,
  yearlyDivisors = [],
  monthlyDivisors = [],
  decimalPlaces = 2
) => {
  if (isValue(dividend)) {
    const yearlyDivisor = yearlyDivisors.reduce(
      (acc, divisor) => acc + divisor,
      0
    );
    const monthlyDivisor = monthlyDivisors.reduce(
      (acc, divisor) => acc + divisor * 12,
      0
    );

    const result = (dividend / (yearlyDivisor + monthlyDivisor)) * 100;

    if (isNaN(result)) {
      return null;
    }

    if (result === Infinity) {
      return result;
    }

    return ((dividend / (yearlyDivisor + monthlyDivisor)) * 100).toFixed(
      decimalPlaces || undefined
    );
  }

  return null;
};

/**
 *
 * @param {number} percent percentage to get monthly value from
 * @param {array} yearlyDivisors yearly divisor amounts used to get percentage
 * @param {array} monthlyDivisors monthly divisor amounts used to get percentage
 * @returns calculated number or null
 */
export const monthlyValueFromYearlyPercent = (
  percent,
  yearlyDivisors = [],
  monthlyDivisors = []
) => {
  if (isValue(percent)) {
    const yearlyDivisor = yearlyDivisors.reduce(
      (acc, divisor) => acc + divisor,
      0
    );
    const monthlyDivisor = monthlyDivisors.reduce(
      (acc, divisor) => acc + divisor * 12,
      0
    );
    return (
      Math.round(
        (((percent / 100) * (yearlyDivisor + monthlyDivisor)) / 12) * 100
      ) / 100
    );
  }

  return null;
};
